export default "__VITE_ASSET__488a77e9__"